import React, { useEffect, useState, useContext, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import { Modal, Button, message } from 'antd'
import MainContext from '../../stores/stores'
import { IMApp } from "@/components/IMApp";
import { useIntl } from 'react-intl';
import styles from './index.module.scss'
import accountApi from '@/api/accountApi';

import { useStateContext } from "@/YXUIKit/im-kit-ui/src";
import { observer } from 'mobx-react'

type ShowChatBtnProps = {
  userInfo: any,
  title: string,
  onClick: () => void,
  enterButton?: React.ReactNode,
}
type IMChatProps = {
  userInfo: any,
  title: string,
  enterButton?: React.ReactNode,
}

const IMChat: React.FC<IMChatProps> = (props) => {
  const navigate = useNavigate()
  const { userInfo, title, enterButton } = props
  const intl = useIntl()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const [show, setShow] = useState<boolean>(false)
  // const [initOptions, setInitOptions] = useState<any>({})

  const [curLanguage, setCurLanguage] = useState<"zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra">('zh')
  // 添加好友是否需要验证
  const [addFriendNeedVerify, setAddFriendNeedVerify] = useState<boolean>(false)
  //单聊消息是否显示已读未读
  const [p2pMsgReceiptVisible, setP2pMsgReceiptVisible] =
    useState<boolean>(true)
  //群聊消息是否显示已读未读
  const [teamMsgReceiptVisible, setTeamMsgReceiptVisible] =
    useState<boolean>(true)
  // 是否需要@消息
  const [needMention, setNeedMention] = useState<boolean>(true)
  // 是否开启群管理员功能
  const [teamManagerVisible, setTeamManagerVisible] = useState<boolean>(true)
  const [enableV2CloudConversation, setEnableV2CloudConversation] = useState<boolean>(true)
  const [aiStream, setAiStream] = useState<boolean>(true)

  useEffect(() => {
    const _languageType = localStorage.getItem('lang') as "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra"
    const _addFriendNeedVerify = sessionStorage.getItem('addFriendNeedVerify')
    const _p2pMsgReceiptVisible = sessionStorage.getItem('p2pMsgReceiptVisible')
    const _teamMsgReceiptVisible = sessionStorage.getItem(
      'teamMsgReceiptVisible'
    )
    const _needMention = sessionStorage.getItem('needMention')
    const _teamManagerVisible = sessionStorage.getItem('teamManagerVisible')
    const _enableV2CloudConversation = sessionStorage.getItem('enableV2CloudConversation')
    const _aiStream = sessionStorage.getItem("aiStream")
    setCurLanguage(_languageType || 'zh')
    if (_p2pMsgReceiptVisible) {
      setP2pMsgReceiptVisible(_p2pMsgReceiptVisible === 'true')
    }
    if (_teamMsgReceiptVisible) {
      setTeamMsgReceiptVisible(_teamMsgReceiptVisible === 'true')
    }
    if (_addFriendNeedVerify) {
      setAddFriendNeedVerify(_addFriendNeedVerify === 'true')
    }
    if (_needMention) {
      setNeedMention(_needMention === 'true')
    }
    if (_teamManagerVisible) {
      setTeamManagerVisible(_teamManagerVisible === 'true')
    }
    if(_enableV2CloudConversation) {
      setEnableV2CloudConversation(_enableV2CloudConversation === 'true')
    }else {
      setEnableV2CloudConversation(false)
    }
    if(_aiStream) {
      setAiStream(true)
    }
  }, [])

  const toChat = () => {
    if(!localStorage.getItem("token") || localStorage.getItem('tourist_user')) {
      navigate('/login')
      return false
    }
    setShow(true)
  }
  const RenderButton = () => {
    return (
      <div onClick={toChat} className={styles['render-btn-wrap']}>
        {enterButton}
      </div>
    )
  }
  return (
    <>
      {
        commonStore.imChatData.appKey && localStorage.getItem("token") && (!localStorage.getItem('tourist_user')) ? <ShowChatBtn onClick={toChat} userInfo={userInfo} title={title} enterButton={enterButton}/> : (enterButton ? <RenderButton/> : <Button type="primary" onClick={toChat}>
          <span className='icon iconfont icon-huihua' style={{marginRight: curLanguage === 'ara' ? 0 : 5, marginLeft: curLanguage === 'ara' ? 5 : 0}}></span>
          {intl.formatMessage({id: '沟通'})}
        </Button>)
      }
      {
        show ? <Modal
          open={show}
          footer={null}
          width={1070}
          wrapClassName='im-chat-modal'
          className='im-chat-content'
          onCancel={() => setShow(false)}
        >
          <div className='container'>
            {
              commonStore.imChatData.appKey ? <IMApp
                // onLogout={onLogout}
                appkey={commonStore.imChatData.appKey}
                account={commonStore.imChatData.account}
                locale={curLanguage}
                addFriendNeedVerify={addFriendNeedVerify}
                p2pMsgReceiptVisible={p2pMsgReceiptVisible}
                teamMsgReceiptVisible={teamMsgReceiptVisible}
                needMention={needMention}
                teamManagerVisible={teamManagerVisible}
                enableV2CloudConversation={enableV2CloudConversation}
                aiStream={aiStream}
              /> : null
            }
          </div>
        </Modal> : null
      }
      
    </>
    
  );
}

const ShowChatBtn: React.FC<ShowChatBtnProps> = observer((props: any) => {
  const intl = useIntl()
  const lang = localStorage.getItem('lang') || 'zh'
  const { onClick, userInfo, title, enterButton } = props
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { nim, store } = useStateContext();
  const [chatInfo, setChatInfo] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if(userInfo.repair_shop_id) {
      getChatInfo()
    }
  }, [userInfo])
  useEffect(() => {
    if(nim && commonStore.isOperate) {
      setNick()
    }
  }, [userInfo, chatInfo, store, nim, commonStore.isOperate])
  
  const getChatInfo = () => {
    accountApi.getChatInfo({
      repair_shop_id: userInfo && userInfo.repair_shop_id ? userInfo.repair_shop_id : '',
      select_merchant_id: userInfo && userInfo.merchant_id ? userInfo && userInfo.merchant_id : ''
    }).then((res: any) => {
      if(res.code === 1) {
        let _data = res.data ? res.data : {}
        setChatInfo(_data)
      }
    })
  }
  const setNick = async () => {
    let repair_shop_name = commonStore.userInfo && commonStore.userInfo.repair_shop_name ? commonStore.userInfo.repair_shop_name : ''
    let wechat_nick = commonStore.userInfo && commonStore.userInfo.wechat_nick ? commonStore.userInfo.wechat_nick : ''
    let avatar = commonStore.userInfo && commonStore.userInfo.avatar ? commonStore.userInfo.avatar : 'https://cdns.007vin.com/img/autorepair/avtor.png'
    let accid = chatInfo.accid ? chatInfo.accid : ''
    let account = commonStore.imChatData.account
    let merchant_name = userInfo && userInfo.merchant_name ? userInfo.merchant_name : ''
    let real_name = chatInfo.real_name ? chatInfo.real_name : ''
    let myNick = repair_shop_name + '-' + wechat_nick
    let toNick = merchant_name + '-' + real_name
    if(accid) {
      let relationInfo = await store.uiStore.getRelation(accid)
      if(relationInfo.relation === 'stranger') {
        await store.friendStore.addFriendActive(accid, {
          addMode: 1,
          postscript: ''
        })
      }
      if(myNick) {
        let user = await store.userStore.getUserForceActive(account)
        if(user.name !== myNick) {
          let params: any = {
            ...user,
            nick: myNick,
            avatar: avatar
          }
          let res = await store.userStore.updateSelfUserProfileActive(params)
        }else if(!user.avatar) {
          let params: any = {
            ...user,
            avatar: avatar
          }
          let res = await store.userStore.updateSelfUserProfileActive(params)
        }
      }
      if(toNick) {
        let res = await store.friendStore.setFriendInfoActive(accid, {
          alias: toNick
        })
      }
      let friendList = await store.friendStore.getFriendListActive()
      friendList.map((item: any) => {
        let accountId = item.accountId
        if(store.conversationStore) {
          store.conversationStore.insertConversationActive(1, accountId, true)
        }
      })
    }
  }
  const toChat = async () => {
    let accid = chatInfo.accid ? chatInfo.accid : ''
    setLoading(true)
    if(accid) {
      let relationInfo = await store.uiStore.getRelation(accid)
      if(relationInfo.isInBlacklist) {
        await store.relationStore.removeUserFromBlockListActive(accid)
      }
      let href = window.location.href
      let msg = title + href
      const conversationId =
      nim.V2NIMConversationIdUtil.p2pConversationId(accid)
      await store.uiStore.selectConversation(conversationId)
      const textMsg = nim.V2NIMMessageCreator.createTextMessage(msg)

      await store.msgStore.sendMessageActive({
        msg: textMsg,
        conversationId,
      })
      if(store.conversationStore) {
        await store.conversationStore.insertConversationActive(1, accid, true)
      }
      setLoading(false)
      onClick()
    }else {
      setLoading(false)
      message.warning(intl.formatMessage({id: '暂无对话人'}))
    }
    
  }
  const RenderButton = () => {
    return (
      <div onClick={toChat} className={styles['render-btn-wrap']}>
        {enterButton}
      </div>
    )
  }
  return (
    <>
      {
        enterButton ? <RenderButton/> : <Button onClick={toChat} type="primary" loading={loading}>
          <span className='icon iconfont icon-huihua' style={{marginRight: lang === 'ara' ? 0 : 5, marginLeft: lang === 'ara' ? 5 : 0}}></span>
          {intl.formatMessage({id: '沟通'})}
        </Button>
      }
    </>
  )
})
export default IMChat
export {
  ShowChatBtn
}